import { render, staticRenderFns } from "./sessionTagLabels.vue?vue&type=template&id=79a16b66"
import script from "./sessionTagLabels.vue?vue&type=script&lang=js"
export * from "./sessionTagLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports